import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import VerificationCodeInput from '@/components/VerificationCodeInput'
import { APIWeb } from '@/api'
import { Toast } from 'react-vant'
import { useUserInfo } from '@/hooks'
import { useSendCode } from '@/hooks/useSendCode'

export default React.memo(function VerifyEmailCode() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { actions: userActions } = useUserInfo()
  const { sendCode, sendCodeLoading } = useSendCode()
  
  // 从路由状态中获取邮箱地址
  const email = location.state?.email || ''
  
  const [submitLoading, setSubmitLoading] = useState(false)

  // 处理验证码提交
  const handleSubmit = async (code: string) => {
    if (!email || !code) {
      Toast.fail(t('请输入验证码'))
      return
    }

    setSubmitLoading(true)
    try {
      await APIWeb.bindEmail({
        email,
        code
      })
      
      Toast.success({
        message: t('绑定成功'),
        duration: 1500,
        onClose: async () => {
          // 刷新用户信息
          await userActions.refreshUserInfo()
          // 返回首页
          navigate('/home', { replace: true })
        }
      })
    } catch (error: any) {
      console.error('绑定邮箱失败:', error)
      Toast.fail(error.message || t('绑定失败，请检查验证码是否正确'))
    } finally {
      setSubmitLoading(false)
    }
  }

  // 重新发送验证码
  const handleResendCode = async () => {
    if (!email) {
      Toast.fail(t('邮箱地址不能为空'))
      return
    }

    await sendCode({
      account: email,
      scene: 'bind_email'
    })
  }

  return (
    <PageLayout tabbarPage={false}>
      <Header
        leftChildren={<Back />}
        centerChildren={<div className="text-3.75 font-medium text-black">{t('验证')}</div>}
      />
      <div className='px-6 py-6'>
        <VerificationCodeInput
          account={email}
          onSubmit={handleSubmit}
          onResendCode={handleResendCode}
          submitLoading={submitLoading}
          resendLoading={sendCodeLoading}
          submitButtonText={t('确认')}
          title={t('我们刚刚向您发送了验证码')}
          description={t('要登录请输入我们发送至X的安全代码该代码将在10分钟后失效', { account: email })}
        />
      </div>
    </PageLayout>
  )
})
